var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamic-select",
    class: {
      'dynamic-select--border': _vm.hasBorder
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selected,
      expression: "selected"
    }],
    ref: "selectElement",
    class: "s-form-control ".concat(_vm.selectClass),
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_vm.placeholder ? _c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._l(_vm.options, function (option, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": option.disabled === true
      },
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  })], 2), _c('div', {
    staticClass: "dynamic-select__caret"
  }, [_vm.hasBorder ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    }
  })]) : _c('svg', {
    attrs: {
      "width": "19",
      "height": "18",
      "viewBox": "0 0 19 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.38672 13.4707C9.62402 13.4707 9.85254 13.374 10.0107 13.1982L16.418 6.6416C16.5674 6.49219 16.6553 6.29004 16.6553 6.06152C16.6553 5.5957 16.2949 5.23535 15.8291 5.23535C15.6094 5.23535 15.3984 5.32324 15.2402 5.47266L9.39551 11.458L3.54199 5.47266C3.38379 5.32324 3.18164 5.23535 2.94434 5.23535C2.47852 5.23535 2.11816 5.5957 2.11816 6.06152C2.11816 6.29004 2.20605 6.49219 2.36426 6.65039L8.77148 13.1982C8.94727 13.374 9.14941 13.4707 9.38672 13.4707Z",
      "fill": _vm.themeColor
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }